import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const breadcrumbStyles: {
  element: SxProps<Theme>;
  box: SxProps<Theme>;
  crumbContent: SxProps<Theme>;
} = {
  element: {
    display: 'flex',
    alignItems: 'center',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    color: 'inherit',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  crumbContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },
};

export default breadcrumbStyles;
